import DualRangeSlider from "../DualRangeSlider";
import type { HandleInputChange } from "./types";

type MultiRangeInputProps = {
    name: string;
    min?: number;
    max?: number;
    step?: number;
    value?: { min: number; max: number };
    onChange: HandleInputChange;
};

const MultiRangeInput = ({ name, min, max, step = 1, value, onChange }: MultiRangeInputProps) => {
    const rangeValue = value || { min, max };

    return (
        <DualRangeSlider
            min={min}
            max={max}
            step={step}
            onChange={({ min: minValue, max: maxValue }: { min: number; max: number }) => onChange(null, name, { min: minValue, max: maxValue })}
            value={rangeValue}
        />
    );
};

export default MultiRangeInput;
